/** CloudFront GIFs — Family / Kitty / Corporate room-type media */
export const ROOM_TYPE_GIF = {
  family: 'https://d3v65upwswr8r2.cloudfront.net/private/GIF/family+room.gif',
  kitty: 'https://d3v65upwswr8r2.cloudfront.net/private/GIF/kitt+room.gif',
  corporate: 'https://d3v65upwswr8r2.cloudfront.net/private/GIF/corporate+room.gif',
};
